import styled from "styled-components";
import { getPropertyByMedia, getThemeSpace } from "../helpers";
import { buttonVariant, getHeightBySize } from "./helpers";
export const Container = styled.button `
	--button-primary-default-background: #0077cb;
	--button-primary-hover-background: #055187;
	--button-primary-color: #ffffff;

	--button-secondary-default-background: var(--button-primary-color);
	--button-secondary-default-border-color: var(--button-disabled-background);
	--button-secondary-hover-background: #dff0ff;
	--button-secondary-hover-border-color: var(--button-primary-default-background);
	--button-secondary-default-color: #444444;
	--button-secondary-hover-color: var(--button-secondary-hover-border-color);

	--button-text-default-background: transparent;
	--button-text-hover-background: var(--button-secondary-hover-background);
	--button-text-color: var(--button-secondary-hover-border-color);

	--button-disabled-color: #b0b0b0;
	--button-disabled-background: #e7e7e7;

	--button-props-transitions: all 300ms ease-in-out;

	--button-trash-color: #5d5d5d;

	position: relative;
	${({ display }) => (display ? getPropertyByMedia("display", display) : "display: flex;")}
	gap: ${getThemeSpace("16")};
	align-items: center;
	justify-content: center;
	flex-shrink: 0;

	${({ width, isFullWidth }) => {
    if (isFullWidth)
        return "width: 100%;";
    return width ? getPropertyByMedia("width", width) : "width: fit-content;";
}}
	${({ minWidth }) => getPropertyByMedia("min-width", minWidth)}
	${({ maxWidth }) => getPropertyByMedia("max-width", maxWidth)}

	border-radius: ${getThemeSpace("8")};
	padding: 0 12px;

	&[data-detached-icon="true"] {
		padding-left: calc(56px + 16px);
		padding-right: 16px;
		border: 1px solid var(--surface-accent-dark);
	}

	${({ size }) => getHeightBySize(size)}

	&[data-variant="primary"] {
		${buttonVariant.primary}
	}

	&[data-variant='secondary'] {
		${buttonVariant.secondary}
	}

	&[data-variant='text'] {
		${buttonVariant.text}
	}

	&[data-variant='none'] {
		${buttonVariant.none}

		&, i, p {
			color: var(${({ color }) => color});
		}
	}

	& i[data-icon-name='delete-icon'] {
		color: var(--button-trash-color);
	}

	&,
	i,
	p {
		transition: var(--button-props-transitions);
	}

	&[data-loading='false'] {
		cursor: pointer;
	}

	&[data-loading='true'] *:not([class*='loading']) {
		opacity: 0;
	}

	&:disabled {
		cursor: not-allowed;

		&:not([data-variant='text'], [data-variant='none']) {
			background-color: var(--button-disabled-background);
		}

		&[data-detached-icon="true"] {
			border: 1px solid var(--semantic-disable-text);
		}

		&:not([data-detached-icon="true"]) i,
		p {
			color: var(--button-disabled-color);
		}

		.loading-fragment {
			border-color: var(--button-disabled-color) transparent transparent transparent;
		}
	}
`;
//# sourceMappingURL=styles.js.map